import React from "react";
import AccountStatementPage from "../components/AccountStatementPage";

// Business Loan Account Statement. The layout, calculation and PDF are shared
// with the GP Loan statement (components/AccountStatementPage.js).
const AccountStatementReport = () => (
  <AccountStatementPage title="Account Statement Report" endpoint="getAccountStatmentReport" product="BL" />
);

export default AccountStatementReport;
